import { Consent } from "../../types";

export const DEFAULT_CONSENT_OPTIONS = [
  Consent.ANALYTICS,
  Consent.PERFORMANCE,
  Consent.ADVERTISING,
];
